module.exports = __webpack_public_path__ + "b975580875f58325ffbc00039510e871.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/fff-icn-clr.png
// module id = 1767
// module chunks = 0